import { Sentence, SentenceText } from '@/features/legends/components/Sentence'
import {
  type Choice,
  ChoiceSelect,
} from '@/features/legends/components/ChoiceSelect'

export interface ConstantFilterProps {
  value: boolean
  onChange: (value: boolean) => unknown
  isDisabled?: boolean
  testId?: string
}

const values: Choice<boolean>[] = [
  [false, 'False'],
  [true, 'True'],
]

/**
 * "Return [true]": always passes, or never does.
 */
export function ConstantFilter({
  value,
  onChange,
  isDisabled,
  testId,
}: ConstantFilterProps) {
  return (
    <Sentence>
      <SentenceText>Return</SentenceText>
      <ChoiceSelect
        value={value}
        choices={values}
        onChange={onChange}
        isDisabled={isDisabled}
        size="small"
        aria-label="Return value"
        testId={testId}
      />
    </Sentence>
  )
}
